$(document).ready(function () {

  try {
    const $prodSlider = $('.products-slider');
    if ($prodSlider.length) {
      const slideCount = $prodSlider.find('.card-wrapper').length || 4;
      const desktopShow = Math.min(4, Math.max(1, slideCount - 1));
      $prodSlider.not('.slick-initialized').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        arrows: false,
        infinite: true,
        centerPadding: '50px',
        accessibility: false,
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: Math.min(desktopShow, 5) } },
          { breakpoint: 992, settings: { slidesToShow: Math.min(desktopShow, 2) } },
          { breakpoint: 576, settings: { slidesToShow: 1, dots: true } }
        ]
      });
    }
  } catch (err) { console.warn('Init products-slider failed', err); }

  if ($('#prod-prev').length) $('#prod-prev').click(function () { if ($('.products-slider').length) $('.products-slider').slick('slickPrev'); });
  if ($('#prod-next').length) $('#prod-next').click(function () { if ($('.products-slider').length) $('.products-slider').slick('slickNext'); });

  try {
    if ($('.reviews-slider').length) {
      $('.reviews-slider').not('.slick-initialized').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: false,
        arrows: false,
        infinite: true,
        pauseOnHover: true,
        responsive: [
          { breakpoint: 992, settings: { slidesToShow: 2 } },
          { breakpoint: 768, settings: { slidesToShow: 1, dots: true } }
        ]
      });
    }
  } catch (err) { console.warn('Init reviews-slider failed', err); }

  if ($('#review-prev').length) $('#review-prev').click(function () { if ($('.reviews-slider').length) $('.reviews-slider').slick('slickPrev'); });
  if ($('#review-next').length) $('#review-next').click(function () { if ($('.reviews-slider').length) $('.reviews-slider').slick('slickNext'); });

  $('a[href^="#"]').on('click', function (e) {
    const href = this.getAttribute('href');
    if (!href || href === '#' || href.length <= 1) return;
    const id = href.slice(1);
    const targetEl = document.getElementById(id);
    if (targetEl) {
      e.preventDefault();
      $('html, body').stop().animate({ scrollTop: $(targetEl).offset().top - 80 }, 1000);
    }
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() > 50) $('.navbar').addClass('scrolled');
    else $('.navbar').removeClass('scrolled');
  });

  const heroVideo = document.querySelector('.hero-video');
  const progressBar = document.querySelector('#hero-progress-bar .bar');
  const progressKnob = document.querySelector('#hero-progress-bar .knob');
  const progressContainer = document.getElementById('hero-progress-bar');

  if (heroVideo && progressBar && progressContainer && progressKnob) {
    const updateProgress = () => {
      const duration = heroVideo.duration || 0;
      const current = heroVideo.currentTime || 0;
      const percent = duration > 0 ? (current / duration) * 100 : 0;
      progressBar.style.width = `${percent}%`;
      const w = progressContainer.clientWidth;
      const knobX = (percent / 100) * w;
      progressKnob.style.left = `${knobX}px`;
    };

    heroVideo.addEventListener('timeupdate', updateProgress);
    heroVideo.addEventListener('loadedmetadata', updateProgress);

    progressContainer.addEventListener('click', (e) => {
      const rect = progressContainer.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const w = rect.width;
      const seekPercent = Math.min(Math.max(x / w, 0), 1);
      if (!isNaN(heroVideo.duration) && heroVideo.duration > 0) {
        heroVideo.currentTime = seekPercent * heroVideo.duration;
      }
      if (heroVideo.paused) heroVideo.play(); else heroVideo.pause();
    });
  }

  try {
    if ($('.sponsor-slider').length) {
      $('.sponsor-slider').not('.slick-initialized').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        arrows: false,
        infinite: true,
        pauseOnHover: false,
        lazyLoad: 'ondemand',
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 5 } },
          { breakpoint: 992, settings: { slidesToShow: 4 } },
          { breakpoint: 768, settings: { slidesToShow: 3 } },
          { breakpoint: 576, settings: { slidesToShow: 2 } }
        ]
      });
    }
  } catch (err) { console.warn('Init sponsor-slider failed', err); }

  try {
    const tTrack = document.querySelector('.test-track');
    if (tTrack && tTrack.getAttribute('data-use-slick') === 'true') {
      // Slick initialization handled in the testimonials section script
    } else if (tTrack && !tTrack.dataset.nativeInit){
      tTrack.dataset.nativeInit = '1';
      const slides = tTrack.querySelectorAll('.test-slide');
      const prev = document.getElementById('test-prev');
      const next = document.getElementById('test-next');
      const tRoot = tTrack.closest('[id^="shopify-section-"]') || document;
      const bar = tRoot.querySelector('.test-scrollbar');
      const thumb = bar ? bar.querySelector('.test-thumb') : null;

      const updateThumb = () => {
        if (!bar || !thumb) return;
        const total = tTrack.scrollWidth;
        const visible = tTrack.clientWidth;
        const sc = tTrack.scrollLeft;
        const w = bar.clientWidth;
        const tw = Math.max(24, Math.round((visible/total) * w));
        const tl = Math.round((sc/(total-visible)) * (w - tw));
        thumb.style.width = tw + 'px';
        thumb.style.transform = 'translateX(' + (isNaN(tl) ? 0 : tl) + 'px)';
      };

      const slideBy = (dir) => {
        if (!slides.length) return;
        const w = slides[0].offsetWidth;
        const gap = parseInt(getComputedStyle(tTrack).gap||'0',10);
        tTrack.scrollBy({ left: (w+gap)*(dir>0?1:-1), behavior: 'smooth' });
      };

      if (prev) prev.addEventListener('click', ()=> slideBy(-1));
      if (next) next.addEventListener('click', ()=> slideBy(1));
      tTrack.addEventListener('scroll', updateThumb, { passive: true });
      window.addEventListener('resize', updateThumb);
      updateThumb();
    }
  } catch (err) { console.warn('Init native testimonials slider failed', err); }

  $('#comparison').beforeAfter();

  try {
    const slider = document.querySelector('.pro-rec-slider');
    if (slider && !slider.dataset.nativeInit){
      const slickTrack = slider.querySelector('.pro-track');
      if (slickTrack && slickTrack.getAttribute('data-use-slick') === 'true') {
        // Slick initialization handled in the pro-recommend section script
      } else {
      slider.dataset.nativeInit = '1';
      const slides = slider.querySelectorAll('.pro-slide');
      const prevBtn = document.getElementById('pro-rec-prev');
      const nextBtn = document.getElementById('pro-rec-next');
      const pRoot = slider.closest('[id^="shopify-section-"]') || document;
      const indexEl = pRoot.querySelector('.pro-progress .pro-index');
      const track = pRoot.querySelector('.pro-scrollbar');
      const thumb = track ? track.querySelector('.pro-thumb') : null;

      const updateThumb = () => {
        if (!track || !thumb) return;
        const total = slider.scrollWidth;
        const visible = slider.clientWidth;
        const sc = slider.scrollLeft;
        const trackWidth = track.clientWidth;
        const tw = Math.max(24, Math.round((visible/total) * trackWidth));
        const tl = Math.round((sc/(total-visible)) * (trackWidth - tw));
        thumb.style.width = tw + 'px';
        thumb.style.transform = 'translateX(' + (isNaN(tl) ? 0 : tl) + 'px)';
      };

      const currentIndex = () => {
        if (!slides.length) return 0;
        const center = slider.scrollLeft + slider.clientWidth/2;
        let nearest = 0, best = Infinity;
        for (let i=0;i<slides.length;i++){
          const r = slides[i].getBoundingClientRect();
          const cr = slider.getBoundingClientRect();
          const mid = (r.left - cr.left) + slides[i].offsetWidth/2 + slider.scrollLeft;
          const d = Math.abs(mid - center);
          if (d < best){ best = d; nearest = i; }
        }
        return nearest;
      };

      const updateIndex = () => {
        if (!indexEl) return;
        const ci = currentIndex();
        const total = slides.length || 0;
        const show = (n) => (n<10?('0'+n):n);
        indexEl.textContent = '[ ' + show(ci+1) + ' / ' + show(total) + ' ]';
      };

      const slideBy = (dir) => {
        if (!slides.length) return;
        const w = slides[0].offsetWidth;
        const gap = parseInt(getComputedStyle(slider).gap||'0',10);
        slider.scrollBy({ left: (w+gap)*(dir>0?1:-1), behavior: 'smooth' });
      };

      if (prevBtn) prevBtn.addEventListener('click', ()=> slideBy(-1));
      if (nextBtn) nextBtn.addEventListener('click', ()=> slideBy(1));
      // drag-to-scroll on slider
      let dragging = false, startX = 0, startScroll = 0, pointerId = null;
      slider.addEventListener('pointerdown', (e)=>{
        pointerId = e.pointerId;
        dragging = true; startX = e.clientX; startScroll = slider.scrollLeft;
        slider.classList.add('grabbing');
        slider.setPointerCapture(pointerId);
      });
      slider.addEventListener('pointermove', (e)=>{
        if (!dragging) return;
        const dx = e.clientX - startX;
        slider.scrollLeft = startScroll - dx;
      });
      const endDrag = (e)=>{
        if (!dragging) return;
        dragging = false; slider.classList.remove('grabbing');
        try{ slider.releasePointerCapture(pointerId); }catch(_){ }
        updateThumb(); updateIndex();
      };
      slider.addEventListener('pointerup', endDrag);
      slider.addEventListener('pointerleave', endDrag);
      // interactive scrollbar (track click + thumb drag)
      let thumbDrag = false, dragOffset = 0, trackRect = null;
      const scrollFromThumbLeft = (left)=>{
        const total = slider.scrollWidth;
        const visible = slider.clientWidth;
        const trackWidth = track.clientWidth;
        const tw = Math.max(24, Math.round((visible/total) * trackWidth));
        const max = Math.max(trackWidth - tw, 0);
        const clamped = Math.max(0, Math.min(max, left));
        const target = (clamped / (max || 1)) * (total - visible);
        slider.scrollLeft = target;
      };
      if (track) {
        track.addEventListener('pointerdown', (e)=>{
          e.preventDefault();
          trackRect = track.getBoundingClientRect();
          const clickX = e.clientX - trackRect.left;
          const currentLeft = (thumb.getBoundingClientRect().left - trackRect.left);
          const total = slider.scrollWidth; const visible = slider.clientWidth; const tw = Math.max(24, Math.round((visible/total)*trackRect.width));
          if (e.target === thumb) { thumbDrag = true; dragOffset = clickX - currentLeft; track.setPointerCapture(e.pointerId); slider.classList.add('grabbing'); track.classList.add('dragging'); }
          else { scrollFromThumbLeft(clickX - tw/2); }
        });
        track.addEventListener('pointermove', (e)=>{
          if (!thumbDrag) return;
          const left = (e.clientX - trackRect.left) - dragOffset;
          scrollFromThumbLeft(left);
        });
        const endThumb = (e)=>{ if (!thumbDrag) return; thumbDrag = false; slider.classList.remove('grabbing'); track.classList.remove('dragging'); try{ track.releasePointerCapture(e.pointerId); }catch(_){ } };
        track.addEventListener('pointerup', endThumb);
        track.addEventListener('pointerleave', endThumb);
      }
      slider.addEventListener('scroll', ()=>{ updateThumb(); updateIndex(); }, { passive: true });
      window.addEventListener('resize', ()=>{ updateThumb(); updateIndex(); });
      updateThumb();
      updateIndex();
      }
    }
  } catch (err) { console.warn('Init native pro-rec-slider failed', err); }
});
